import ApiClient from "./apiCient.js";

const base_URL = process.env.REACT_APP_API_BASE_URL;
class AdminApi extends ApiClient {
    constructor() {
        super(base_URL);
  }

  verifyUsers(data) {
    return this.post("/cc/verify-users", data);
  }

  getUnverifiedUsers() {
    return this.get(`/cc/get-unverified-users`);
  }

  createUser(data) {
    return this.post("/users", data);
  }

  updateUser(id, data) {
    return this.put(`/users/${id}`, data);
  }

  deleteUser(feed_id) {
    return this.get(`/admin/delete-feed?feed_id=${feed_id}`);
  }

    upsertFeed(data) {
        return this.post("admin/upsert-feed", data);
    }

    hideFeed(feed_id, show) {
        return this.get(`/admin/hide-feed?feed_id=${feed_id}&show=${!show}`);
    }

    deleteFeed(feed_id) {
        return this.get(`/admin/delete-feed?feed_id=${feed_id}`);
    }

    allFeeds() {
        return this.get("/admin/get-feeds");

    }

    upsertEvent(data) {
        return this.post("/admin/upsert-event", data);
    }

    allEvents() {
        return this.get("/admin/get-events");

    }

    deleteEvent(event_id) {
        return this.get(`/admin/delete-event?event_id=${event_id}`);
    }
}

const adminAPIs = new AdminApi();
export default adminAPIs
